import $ from '@modules/jquery-import';

$.fn.forceNumericRange = function ( opt ) {

    var defaults = {
            min: 0,
            max: 100
        },
        opt = $.extend( {}, defaults, opt ),
        hintTarget = function ( $target ) {
            return function ( msg ) {
                $target.showHint( msg, {
                    hide_trigger: 'keydown'
                } );
            }
        };

    return this.each( function () {
        $( this ).on( 'keypress', function ( e ) {

            var $input = $( this ),
                val = parseInt( this.value + String.fromCharCode( e.which ), 10 ),
                minVal = parseInt( this.getAttribute( 'min' ), 10 ) || opt.min,
                maxVal = parseInt( this.getAttribute( 'max' ), 10 ) || opt.max,
                showHint = hintTarget( $input );

            if ( !isNaN( val ) ) {
                if ( !isNaN( minVal ) && val < minVal ) {
                    showHint( 'Minimum quantity ' + minVal );
                    this.value = minVal;
                    $( this ).trigger( 'change' );
                    return false;
                }
                if ( !isNaN( maxVal ) && val > maxVal ) {
                    showHint( 'Maximum quantity ' + maxVal );
                    this.value = maxVal;
                    $( this ).trigger( 'change' );
                    return false;
                }
            }
        } )
    } );
};
